import { Injectable } from '@angular/core';
import {plainToInstance} from 'class-transformer';
import {HierarchyNodeModel} from './models/hierarchy-node.model';
import {MesApiService} from 'common-shared';
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FilterByHierarchyModel } from './models/filter-by-hierarchy.model';

@Injectable({
  providedIn: 'root'
})
export class HierarchyNodeService extends MesApiService {
  constructor() {
    super('HierarchyNode');
  }

  getRootWithHierarchy() {
    return this.getSingle<HierarchyNodeModel>({
      action: 'GetRootWithHierarchy'
    }).pipe(map(value => {
      return plainToInstance(HierarchyNodeModel, value.data);
    }));
  }

  getNodeWithHierarchy(id: string) {
    return this.getSingle<HierarchyNodeModel>({
      action: 'GetNodeWithHierarchy'
    }, {
      nodeId: id
    }).pipe(map(value => {
      return plainToInstance(HierarchyNodeModel, value.data);
    }));
  }

  addNew(hierarchyNodeModel: HierarchyNodeModel) {
    return this.add<HierarchyNodeModel>(hierarchyNodeModel, {
      action: 'Post'
    }).pipe(map(value => {
      return plainToInstance(HierarchyNodeModel, value.data);
    }));
  }

  save(hierarchyNodeModel: HierarchyNodeModel): Observable<HierarchyNodeModel> {
    return this.update<HierarchyNodeModel>(hierarchyNodeModel.Id, hierarchyNodeModel).pipe(map(value => {
      return plainToInstance(HierarchyNodeModel, value.data);
    }));
  }

  getGroupsInHierarchy(ids: string[]): Observable<FilterByHierarchyModel[]> {
    return this.updateGet<string[], FilterByHierarchyModel[]>(ids[0], { NodeIds: ids }, {
      action: 'GetGroupsInHierarchy'
    }).pipe(map(value => {
      return plainToInstance(FilterByHierarchyModel, value.data);
    }));
  }

  flatten(arr: HierarchyNodeModel[]): HierarchyNodeModel[] {
    return arr.reduce((flat: HierarchyNodeModel[], toFlatten: HierarchyNodeModel) => {
      flat = Array.isArray(toFlatten.Children)
        ? flat.concat(toFlatten)
        : flat;
      return flat.concat(
        Array.isArray(toFlatten.Children)
          ? this.flatten(toFlatten.Children)
          : toFlatten);
    }, []);
  }
}
